export const GET_DASHBOARD_SUMMARY = "GET_DASHBOARD_SUMMARY";
export const GET_DASHBOARD_SUMMARY_SUCCESS = "GET_DASHBOARD_SUMMARY_SUCCESS";
export const GET_DASHBOARD_SUMMARY_ERROR = "GET_DASHBOARD_SUMMARY_ERROR";
